import React from 'react'
import PropTypes from 'prop-types'

const TestDriveIcon = ({ accentColor }) => {
  return (
    <svg
      width="66"
      height="52"
      viewBox="0 0 66 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6041 51.2971C36.5677 51.2971 47.0769 40.7198 47.0769 27.672C47.0769 14.6241 36.5677 4.0468 23.6041 4.0468C10.6405 4.0468 0.131348 14.6241 0.131348 27.672C0.131348 40.7198 10.6405 51.2971 23.6041 51.2971Z"
        fill={accentColor}
      />
      <path
        d="M18.5249 27.7292C19.595 27.7292 20.4624 26.8617 20.4624 25.7917C20.4624 24.7216 19.595 23.8542 18.5249 23.8542C17.4549 23.8542 16.5874 24.7216 16.5874 25.7917C16.5874 26.8617 17.4549 27.7292 18.5249 27.7292Z"
        fill="#31333D"
      />
      <path
        d="M30.1499 27.7292C31.22 27.7292 32.0874 26.8617 32.0874 25.7917C32.0874 24.7216 31.22 23.8542 30.1499 23.8542C29.0799 23.8542 28.2124 24.7216 28.2124 25.7917C28.2124 26.8617 29.0799 27.7292 30.1499 27.7292Z"
        fill="#31333D"
      />
      <path
        d="M24.5957 29.0208H15.2957V22.95L15.4249 22.5625H33.2499L33.3791 22.95V25.7917L35.9624 23.2083V22.5625L33.2499 14.8125C32.9916 14.0375 32.2166 13.5208 31.4416 13.5208H17.2332C16.3291 13.5208 15.6832 14.0375 15.4249 14.8125L12.7124 22.5625V32.8958C12.7124 33.5417 13.2291 34.1875 14.0041 34.1875H15.2957C15.9416 34.1875 16.5874 33.5417 16.5874 32.8958V31.6042H22.1416L23.8207 29.925L24.5957 29.0208ZM17.6207 16.1042H30.9249L32.2166 19.9792H16.3291L17.6207 16.1042Z"
        fill="#31333D"
      />
      <path
        d="M38.9336 27.8584L36.9961 26.05L30.2794 32.7667L27.5669 30.0542L25.6294 31.8625L30.2794 36.6417L32.2169 34.7042L38.9336 27.8584Z"
        fill="#31333D"
      />
      <path
        d="M12.8096 5.49757C16.7024 2.60664 21.5211 0.891144 26.7396 0.891144C33.1575 0.891144 38.9652 3.47498 43.2053 7.67901"
        stroke="#31333D"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M45.5091 38.7168C41.227 44.4457 34.4093 48.152 26.7393 48.152C13.7773 48.152 3.2666 37.5731 3.2666 24.5269C3.2666 17.7178 6.12836 11.5865 10.6946 7.27658"
        stroke="#31333D"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M43.4102 10L40 30.5497L45.2296 31.4828L44.2642 37L50.8374 32.4807L62.5272 34.4558L66 13.6947L43.4102 10Z"
        fill={accentColor}
      />
      <path
        d="M59.8853 11.5545L45.4606 9L44.3559 15.6959L43.3122 22.0216L42.2686 28.3473L46.8832 29.1721L46.0318 34.0329L51.8399 30.045L60.9872 31.7768L64.1987 12.293L61.93 11.9149"
        fill={accentColor}
      />
      <path
        d="M59.8853 11.5545L45.4606 9L44.3559 15.6959L43.3122 22.0216L42.2686 28.3473L46.8832 29.1721L46.0318 34.0329L51.8399 30.045L60.9872 31.7768L64.1987 12.293L61.93 11.9149"
        stroke="#31333D"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M59.7406 14.8373L58.9909 14.7011L59.2633 13.2016L57.7638 12.9292L57.4914 14.4287L51.4934 13.3391L51.7658 11.8396L50.2663 11.5672L49.9939 13.0667L49.2442 12.9305C48.4195 12.7807 47.6221 13.3329 47.4723 14.1576L45.5656 24.6541C45.4157 25.4788 45.9679 26.2762 46.7927 26.426L57.2891 28.3327C58.1138 28.4825 58.9112 27.9303 59.061 27.1056L60.9677 16.6092C61.1176 15.7845 60.5654 14.9871 59.7406 14.8373ZM57.5615 26.8332L47.0651 24.9265L48.427 17.429L58.9235 19.3358L57.5615 26.8332ZM59.1959 17.8363L48.6994 15.9295L48.9718 14.43L59.4682 16.3368L59.1959 17.8363ZM53.2667 20.6316L57.0154 21.3126L56.3344 25.0613L52.5857 24.3804L53.2667 20.6316Z"
        fill="#31333D"
      />
    </svg>
  )
}

TestDriveIcon.propTypes = {
  accentColor: PropTypes.string,
}

export default TestDriveIcon
